import BaseAPI from "./BaseAPI";
import { locationRoute } from "../routes";
import { newIdempotencyKey } from "@/composables/globalMethods";

export default class LocationAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, locationRoute, "location");
    }

    async Add(data, idempotencyKey = newIdempotencyKey()) {
        return super.Add(data, idempotencyKey);
    }
}
